export enum WalkabilityLevel {
  WALKERS_PARADISE = 'walkers_paradise',
  WALKABLE = 'walkable',
  SOMEWHAT_WALKABLE = 'somewhat_walkable',
  CAR_DEPENDENT = 'car_dependent'
}

export enum TraficLevel {
  FLUID = 'fluid',
  MODERATE = 'moderate',
  HEAVY = 'heavy',
  VERY_HEAVY = 'very_heavy'
}
